import { Moment } from 'moment';
// Constants
import { isoDateFormat } from 'constants/global';

type StatsDataItem = {
  date: string;
  total?: number;
};

export type TicketStats = { ticket_order?: StatsDataItem[] } | null | undefined;

export type TicketSalesPoint = {
  date: string;
  value: number;
  orders: number;
};

export const getTicketSalesSeries = (
  values: TicketStats,
  counts: TicketStats,
  startDate: Moment,
  endDate: Moment
): TicketSalesPoint[] => {
  const valueByDay = new Map(
    (values?.ticket_order || []).map((item) => [item.date, item.total || 0])
  );
  const ordersByDay = new Map(
    (counts?.ticket_order || []).map((item) => [item.date, item.total || 0])
  );
  const points: TicketSalesPoint[] = [];
  const day = startDate.clone().startOf('day');
  const last = endDate.clone().startOf('day');

  while (!day.isAfter(last)) {
    const date = day.format(isoDateFormat);
    points.push({
      date,
      value: valueByDay.get(date) || 0,
      orders: ordersByDay.get(date) || 0,
    });
    day.add(1, 'day');
  }

  return points;
};
